import CoveredInClassHFv4 from './component';
import Privileges from 'domain/Privileges';
import { PrivilegeChecker } from 'omni-common-ui';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import SessionNav from 'containers/Group/SessionNav';
import { getDefaultSession, getFirstUnitOfSession } from 'data/SessionPlans/accessors';
import { accessors } from 'data/CoveredInClass';
import ViewNav from './ViewNavCIC';
import { actions as groupActions } from 'containers/Group';

export const Modes = {
  PUBLISH: 'publish-to-ef-p',
  EXPORT: 'export',
  ADD_NOTES: 'add-notes',
  EDIT_NOTES: 'edit-notes',
  DELETE_NOTES: 'delete-notes',
  ADD_FREE_TEXT: 'add-free-text',
  CLEAR: 'clear',
};

const SHOW_ADD_NOTES = false;

const actionButtons = (getState) => ({
  PUBLISH: {
    isPrimary: true,
    route: `./${Modes.PUBLISH}`,
    visibleWhen: ({ params }) =>
          ! groupActions.isAutoPublishCIC(getState(), params.groupId) &&
          ! groupActions.isHFV4CourseTypeGroup(getState(), params.groupId) &&
          accessors.isNotPublished(getState(), params) &&
          accessors.isNotFutureSession(getState(), params),
    disableWhen: ({ params: { mode, sessionPlanId } }) => {
      const coveredInClassObject = accessors.getCoveredInClassObject(getState(), sessionPlanId);
      const hasPrivilege =
        PrivilegeChecker.hasPrivilege(getState(), Privileges.CoveredInClass.MarkAndPublish);
      // OMO-2376: Publish button is disabled if all items are unchecked
      return ! hasPrivilege ||
        isInEditNoteMode(mode) ||
        accessors.isAllCategoryItemsUnchecked(coveredInClassObject);
    },
  },
  EXPORT: {
    isPrimary: false,
    route: `./${Modes.EXPORT}`,
    visibleWhen: ({ params }) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.CoveredInClass.PrintCoveredInClass) &&
          ! groupActions.isNotTBv3Group(getState(), params.groupId) &&
          ! groupActions.isHFV4CourseTypeGroup(getState(), params.groupId) &&
          accessors.isNotFutureSession(getState(), params) &&
          accessors.hasCICTemplate(getState(), params),
    disableWhen: ({ params: { mode } }) => isInEditNoteMode(mode),
  },
  'ADD NOTES': {
    isPrimary: false,
    route: `./${Modes.ADD_NOTES}`,
    visibleWhen: () => SHOW_ADD_NOTES &&
      PrivilegeChecker.hasPrivilege(getState(), Privileges.CoveredInClass.AddCommentToInternal),
    disableWhen: ({ params: { mode } }) => isInEditNoteMode(mode),
  },
  'ADD FREE TEXT': {
    isPrimary: false,
    route: `./${Modes.ADD_FREE_TEXT}`,
    visibleWhen: ({ params }) =>
      ! groupActions.isAutoPublishCIC(getState(), params.groupId) &&
    ! groupActions.isHFV4CourseTypeGroup(getState(), params.groupId) &&
      PrivilegeChecker.hasPrivilege(getState(), Privileges.CoveredInClass.AddCommentToInternal) &&
      accessors.isNotPublished(getState(), params) &&
          accessors.isNotFutureSession(getState(), params),
    disableWhen: ({ params: { mode } }) => isInEditNoteMode(mode),
  },
  CLEAR: {
    isPrimary: false,
    route: `./${Modes.CLEAR}`,
    visibleWhen: ({ params }) =>
      ! accessors.isNotPublished(getState(), params) &&
          accessors.hasWronglyResult(getState(), params.sessionPlanId),
  },
});

export default ({ getState }) => ({
  appBars: {
    sticky: {
      'session-nav': {
        component: SessionNav,
        order: 1,
      },
      'view-nav': {
        component: ViewNav,
        order: 2,
      },
    },
  },
  path: 'session/:sessionPlanId(/unit/:unitId)/covered-in-class-hfv4(/:mode)(/:index)',
  component: CoveredInClassHFv4,
  canAccess: ({ params }) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.CoveredInClass.ViewCoveredInClass) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.CoveredInClassAndHomeworkHFv4),
  tab: {
    label: 'Homework & CIC',
    order: 2,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.CoveredInClass.ViewCoveredInClass) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.CoveredInClassAndHomeworkHFv4),
    params: (currentParams) => {
      const defaultSession = getDefaultSession(getState(), currentParams.groupId);
      const sessionPlanId = defaultSession && defaultSession.id;
      return {
        ...currentParams,
        sessionPlanId,
        unitId: getFirstUnitOfSession(getState(), sessionPlanId),
        mode: '',
      };
    },
  },
  breadcrumbLabels: (props) =>
    [{
      label: 'Homework & CIC',
      clickable: false,
    }, `Session ${accessors.getCurrentSessionNumber(getState(), props) || ''}`],
  actionButtons: {
    default: actionButtons(getState),
    [Modes.ADD_NOTES]: actionButtons(getState),
    [Modes.EDIT_NOTES]: actionButtons(getState),
    [Modes.ADD_FREE_TEXT]: actionButtons(getState),
    [Modes.CLEAR]: actionButtons(getState),
  },
});

export function isInEditNoteMode(mode) {
  return mode === Modes.ADD_NOTES || mode === Modes.EDIT_NOTES || mode === Modes.ADD_FREE_TEXT;
}



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClassHFv4/routes.js